export default "__VITE_ASSET__8aade43e__"